/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import dayjs from 'dayjs';
import { FC } from 'react';
import { useMiddlewareContext } from '../../hooks/useMiddlewareContext';
import { ECalendarMode, ECalendarView, IDraggableProps } from '../../types';
import { calculateNewDate } from '../../utils';
import { oneHourHeight, oneHourWidth } from '../../utils/timeUtils';
import { isDailyMode } from '../../utils/dnd';
import { DateTimeFormats, TimeUnit } from '@bondsports/date-time';
import { getCombinedDateTimeString } from '../../../lib/timeUtils';

export enum EAxis {
	ALL,
	VERTICAL,
	HORIZONTAL,
}

export const Draggable: FC<IDraggableProps> = ({ item, delta, Component, view, mode }) => {
	const { options } = useMiddlewareContext();

	let startDate: string = item?.startDate || '';
	let endDate: string = item?.endDate || '';
	let startTime: string = item?.startTime || '';
	let endTime: string = item?.endTime || '';

	if (item && isDailyMode(mode)) {
		const size = view === ECalendarView.VERTICAL ? oneHourHeight : oneHourWidth;

		const stepSize: number = options.dndStepLength! || 1;
		const minutesDifference: number = Math.round((Number(delta) * (60 / size)) / stepSize) * stepSize;

		startDate = dayjs
			.utc(getCombinedDateTimeString(startDate, item.startTime))
			.add(minutesDifference, TimeUnit.MINUTE)
			.format(DateTimeFormats.YYYY_MM_DD_T_HH_MM_SS);

		endDate = dayjs
			.utc(getCombinedDateTimeString(endDate, item.endTime))
			.add(minutesDifference, TimeUnit.MINUTE)
			.format(DateTimeFormats.YYYY_MM_DD_T_HH_MM_SS);

		startTime = dayjs.utc(startDate).format(DateTimeFormats.H24_WITH_SECONDS);
		startDate = dayjs.utc(startDate).format(DateTimeFormats.YYYY_MM_DD);

		endTime = dayjs.utc(endDate).format(DateTimeFormats.H24_WITH_SECONDS);
		endDate = dayjs.utc(endDate).format(DateTimeFormats.YYYY_MM_DD);
	}

	return (
		<div style={{ cursor: 'grabbing', height: '100%' }} key={item?.id ? `Draggable-${item?.id}` : undefined}>
			{item && (
				<Component
					event={{
						...item,
						startDate,
						endDate,
						startTime,
						endTime,
					}}
					key={`Draggable-Component-${item.id}`}
					currentDate={mode === ECalendarMode.DAILY ? options.date! : startDate!}
					mode={mode}
				/>
			)}
		</div>
	);
};
